export const carsS = [
  {
    id: Math.random(),
    name: "Truffade Adder",
    url: "https://gtacars.net/images/8866294c242a925d4e20170282a3fdfd",
    accel: "74%",
    tops: "75%",
    grip: "72%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Overflod Autarch",
    url: "https://gtacars.net/images/213dc2b50d169485c92cff56abc7b58d",
    accel: "76%",
    tops: "77%",
    grip: "79%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Vapid Bullet",
    url: "https://gtacars.net/images/288057fc7869f5f9d344292a1a00c419",
    accel: "74%",
    tops: "77%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Grotti Carbonizzare",
    url: "https://gtacars.net/images/81911488704264e57446a88f9bd5854d",
    accel: "74%",
    tops: "75%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Dewbauchee Champion",
    url: "https://gtacars.net/images/158bb4a74e98a84fde2867442be9f626",
    accel: "76%",
    tops: "75%",
    grip: "74%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Grotti Cheetah",
    url: "https://gtacars.net/images/9bf4d9bcf46b953bb655afbffd5645fb",
    accel: "77%",
    tops: "78%",
    grip: "73%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Grotti Cheetah Classic",
    url: "https://gtacars.net/images/ba4ba835632f6768a67a7726a620974b",
    accel: "77%",
    tops: "78%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "red",
  },
  {
    id: Math.random(),
    name: "Invetero Coquette D10",
    url: "https://gtacars.net/images/4ef2f283a9428d1f3641e76c0307a043",
    accel: "77%",
    tops: "75%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Lampadati Corsita",
    url: "https://gtacars.net/images/1d4ec83f0958af6288ff16197aa627b5",
    accel: "77%",
    tops: "78%",
    grip: "72%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Principe Deveste Eight",
    url: "https://gtacars.net/images/c9817dfaeb9e8162cabbfcb98242814d",
    accel: "78%",
    tops: "78%",
    grip: "70%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Progen Emerus",
    url: "https://gtacars.net/images/a9fb410a0ba8cdf728f25d293e37ecd5",
    accel: "77%",
    tops: "77%",
    grip: "73%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Overflod Entity XXR",
    url: "https://gtacars.net/images/e9195ad077bd55e4b21de7d93002cd0c",
    accel: "78%",
    tops: "76%",
    grip: "71%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Overflod Entity MT",
    url: "https://gtacars.net/images/032eef3c73441b795f58763333a539dd",
    accel: "77%",
    tops: "75%",
    grip: "71%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Overflod Entity XF",
    url: "https://gtacars.net/images/82f09e0204cad64f01ff3c2b3ca8b280",
    accel: "78%",
    tops: "76%",
    grip: "74%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Emperor ETR1",
    url: "https://gtacars.net/images/ed9d0d568994d9e9022ad0534909f01e",
    accel: "76%",
    tops: "74%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Vapid FMJ",
    url: "https://gtacars.net/images/62ecea12bb863e78984b1b977f85fe4a",
    accel: "76%",
    tops: "75%",
    grip: "73%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },

  {
    id: Math.random(),
    name: "Grotti Furia",
    url: "https://gtacars.net/images/248ef8231feb8c7daeeb30d4754bc4eb",
    accel: "75%",
    tops: "75%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Progen GP1",
    url: "https://gtacars.net/images/cf0a6050551426fee4fd7d4c95fba829",
    accel: "75%",
    tops: "75%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Pegassi Ignus",
    url: "https://gtacars.net/images/78bcc5b51115aca5bf45540c3680cda2",
    accel: "75%",
    tops: "75%",
    grip: "79%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Pegassi Infernus",
    url: "https://gtacars.net/images/ab29494a59ae97f2953d801ee786cf48",
    accel: "72%",
    tops: "76%",
    grip: "73%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Pegassi Infernus Classic",
    url: "https://gtacars.net/images/0d0838a019bd6bf7d122110f0c78bed1",
    accel: "74%",
    tops: "76%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Progen Itali GTB",
    url: "https://gtacars.net/images/7eec638035a0e36c6360c5e588e86534",
    accel: "76%",
    tops: "73%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Progen Itali GTB C",
    url: "https://gtacars.net/images/71cedbcd3b2e6000b2e155b57ffd130b",
    accel: "76%",
    tops: "75%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Progen Itali RSX",
    url: "https://gtacars.net/images/74042388552efb0b3b4b483fccfbdba9",
    accel: "76%",
    tops: "75%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Dinka Jester",
    url: "https://gtacars.net/images/5fff3c45323e5357d1728980c1033773",
    accel: "77%",
    tops: "74%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Dinka Jester RC",
    url: "https://gtacars.net/images/fa80850ecd0d4900a22407bef85f12a8",
    accel: "77%",
    tops: "77%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Benefactor Krieger",
    url: "https://gtacars.net/images/db239a13b8e1de143facc23820ba8d84",
    accel: "73%",
    tops: "73%",
    grip: "78%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Benefactor LM87",
    url: "https://gtacars.net/images/176f17ece6a34573ed90defdb63373ac",
    accel: "74%",
    tops: "74%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Ocelot Locust",
    url: "https://gtacars.net/images/dbb753fd85f671100a99f1c16650d0a6",
    accel: "74%",
    tops: "75%",
    grip: "73%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Ocelot Lynx",
    url: "https://gtacars.net/images/ddb7ae52dfc4684c0d6f10ab6f1a03dd",
    accel: "76%",
    tops: "75%",
    grip: "68%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Vysser Neo",
    url: "https://gtacars.net/images/16a739088af9da2590cc5dbcc68b38dd",
    accel: "75%",
    tops: "74%",
    grip: "72%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Truffade Nero",
    url: "https://gtacars.net/images/786490cd32aaf1226f0f230846c65b81",
    accel: "77%",
    tops: "74%",
    grip: "74%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Truffade Nero C",
    url: "https://gtacars.net/images/81e9ec741f4ff9f0dff9d1803aa18be9",
    accel: "75%",
    tops: "74%",
    grip: "78%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Obey 9F",
    url: "https://gtacars.net/images/fc00d0c7b1a8eb0f3fd44e8de2d2a009",
    accel: "75%",
    tops: "74%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Obey 9F Cabrio",
    url: "https://gtacars.net/images/16aeceef84e24582df7e1c3ec6da2830",
    accel: "75%",
    tops: "74%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Pegassi Osiris",
    url: "https://gtacars.net/images/4d2b6f7dd18cf7b6bd59e0229a3ac156",
    accel: "77%",
    tops: "74%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Ocelot Pariah",
    url: "https://gtacars.net/images/b51ca61e8e72af6c0eca7dd5ab175960",
    accel: "79%",
    tops: "75%",
    grip: "72%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Ocelot Penetrator",
    url: "https://gtacars.net/images/839583d41b51b14ec69f58649e72917e",
    accel: "76%",
    tops: "75%",
    grip: "78%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Pfister 811",
    url: "https://gtacars.net/images/a66803102a89831ef213b67f63d5efe3",
    accel: "76%",
    tops: "75%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Grotti X80 Proto",
    url: "https://gtacars.net/images/c84c5b76abaec9030a170629753b7bab",
    accel: "75%",
    tops: "73%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Annis RE-7B",
    url: "https://gtacars.net/images/71931522da763417acf042ac37f37511",
    accel: "75%",
    tops: "74%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Pegassi Reaper",
    url: "https://gtacars.net/images/671a28ac359e6225402a49f3dbf62a09",
    accel: "75%",
    tops: "75%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Hijak Ruston",
    url: "https://gtacars.net/images/73bcd273c414f901237b2a11ac89ff40",
    accel: "75%",
    tops: "75%",
    grip: "72%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Annis S80RR",
    url: "https://gtacars.net/images/f29bd57d82339b333a11cacb1175700d",
    accel: "75%",
    tops: "75%",
    grip: "73%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Ubermacht SC1",
    url: "https://gtacars.net/images/a0ce0f5203e10cf1507ae952ac843cca",
    accel: "75%",
    tops: "74%",
    grip: "79%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Benefactor SM722",
    url: "https://gtacars.net/images/9bd60a362151566f6b512fb2172b56ba",
    accel: "75%",
    tops: "73%",
    grip: "73%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },

  {
    id: Math.random(),
    name: "Grotti Stinger GT",
    url: "https://gtacars.net/images/8193f7c115438fad82613cff2a5d3418",
    accel: "75%",
    tops: "73%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Grotti Stinger TT",
    url: "https://gtacars.net/images/7acdca8b9c29b91b9bae13c1dd79c6fb",
    accel: "75%",
    tops: "74%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Ocelot Swinger",
    url: "https://gtacars.net/images/2edbe62476081a6748ce398854d0504b",
    accel: "75%",
    tops: "75%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },

  {
    id: Math.random(),
    name: "Progen T20",
    url: "https://gtacars.net/images/ba3b35deddb20bd58e5fe30e0d87b7de",
    accel: "75%",
    tops: "76%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },

  {
    id: Math.random(),
    name: "Cheval Taipan",
    url: "https://gtacars.net/images/25bd05ec3d225730acb383478dd4cc53",
    accel: "79%",
    tops: "76%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Pegassi Tempesta",
    url: "https://gtacars.net/images/41242cbbb2644235ec4bfc72864d0a56",
    accel: "77%",
    tops: "76%",
    grip: "79%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },

  {
    id: Math.random(),
    name: "Obey 10F",
    url: "https://gtacars.net/images/8f6e51fd682edc73229fd8dd65c0f96d",
    accel: "75%",
    tops: "78%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Obey 10F WB",
    url: "https://gtacars.net/images/e2ddb5a37531af5af36ecf58c8ba78d2",
    accel: "76%",
    tops: "78%",
    grip: "77%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "red",
  },
  {
    id: Math.random(),
    name: "Truffade Thrax",
    url: "https://gtacars.net/images/7b61d9d5439d71c0c8dcf9155a9ee885",
    accel: "74%",
    tops: "73%",
    grip: "80%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Lampadati Tigon",
    url: "https://gtacars.net/images/292cca5d9e841983122539c187f9db2a",
    accel: "74%",
    tops: "75%",
    grip: "70%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Pegassi Torero",
    url: "https://gtacars.net/images/82028c7e552b59b486a953377568db8a",
    accel: "76%",
    tops: "77%",
    grip: "74%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Pegassi ToreroXO",
    url: "https://gtacars.net/images/56b3512ea12af71b1f99ed079229fbe6",
    accel: "74%",
    tops: "75%",
    grip: "77%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "red",
  },
  {
    id: Math.random(),
    name: "Grotti Turismo Classic",
    url: "https://gtacars.net/images/aee8a5bc5135b026a3708e9ee8eeb38c",
    accel: "77%",
    tops: "75%",
    grip: "77%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Grotti Turismo R",
    url: "https://gtacars.net/images/3316578ec337a8b9f756c3ad5c7b8703",
    accel: "77%",
    tops: "75%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },

  {
    id: Math.random(),
    name: "Overflod Tyrant",
    url: "https://gtacars.net/images/3dd5c78c7be8efb8579df4afc2c6082d",
    accel: "75%",
    tops: "74%",
    grip: "74%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Progen Tyrus",
    url: "https://gtacars.net/images/f1b11590e373f4dc4f0f2c9c1083c116",
    accel: "75%",
    tops: "74%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Pegassi Vacca",
    url: "https://gtacars.net/images/8e67459cdb0c6e4cbfd66c49514a1f72",
    accel: "75%",
    tops: "74%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Dewbauchee Vagner",
    url: "https://gtacars.net/images/4b6f726db6c90968c397d12eb569d586",
    accel: "77%",
    tops: "74%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Grotti Visione",
    url: "https://gtacars.net/images/0699d68a4b054d19386995135ac603a7",
    accel: "75%",
    tops: "78%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Ocelot XA-21",
    url: "https://gtacars.net/images/7dcf1c5b0b701405edf3c6d9d264233e",
    accel: "77%",
    tops: "76%",
    grip: "76%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer",
    colorAv: "green",
  },
  {
    id: Math.random(),
    name: "Overfold Zeno",
    url: "https://gtacars.net/images/d9598a35e3b37425331dbee1003977d2",
    accel: "76%",
    tops: "77%",
    grip: "74%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Pegassi Zentorno",
    url: "https://gtacars.net/images/2d10df4b2a87755c924fa1f3cc57cc18",
    accel: "76%",
    tops: "75%",
    grip: "78%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Pegassi Zorrusso",
    url: "https://gtacars.net/images/1ae5701d3074736143c13cc10d8b81b2",
    accel: "79%",
    tops: "76%",
    grip: "73%",
    cat: "S",
    colorC: "green",
    avail: "Cardealer / Boosting",
    colorAv: "orange",
  },
  {
    id: Math.random(),
    name: "Ocelot Lynx じこ",
    url: "https://img.gta5-mods.com/q95/images/ocelot-lynx-custom-add-on/20a8f2-a.png",
    accel: "76%",
    tops: "77%",
    grip: "79%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "RED",
    ees: true,
  },
  {
    id: Math.random(),
    name: "Dinka Nexus じこ",
    url: "https://img.gta5-mods.com/q95/images/dinka-nexus/c4a1a4-46576508401_b28481e33d_o.jpg",
    accel: "79%",
    tops: "78%",
    grip: "78%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "RED",
    ees: true,
  },
  {
    id: Math.random(),
    name: "Obey 9F じこ",
    url: "https://img.gta5-mods.com/q95/images/ninef-street-runner-gta-tuners-and-outlaws-concept-car/c1b101-Project%20112.00_00_11_17.Still009.jpg",
    accel: "77%",
    tops: "77%",
    grip: "79%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "RED",
    ees: true,
  },
  {
    id: Math.random(),
    name: "Benefactor Schlagen じこ",
    url: "https://img.gta5-mods.com/q95/images/benefactor-schlagen-str-add-on/98ff94-EVE-20221101001527.052-min.png",
    accel: "76%",
    tops: "75%",
    grip: "81%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "RED",
    ees: true,
  },
  {
    id: Math.random(),
    name: "Karin SultanRS じこ",
    url: "https://img.gta5-mods.com/q95/images/sultan-rsv8-mk2-add-on-tuning-sound-livery-template/cd8360-FiveM_GTAProcess-2020-07-01-12-58-35.png",
    accel: "79%",
    tops: "78%",
    grip: "79%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "RED",
    ees: true,
  },
  {
    id: Math.random(),
    name: "Vapid Bullet じこ",
    url: "https://img.gta5-mods.com/q95/images/vapid-bullet-gt-add-on-tuning-liveries-template/361663-EVE-20190303143949.182.jpg",
    accel: "75%",
    tops: "76%",
    grip: "81%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "RED",
    ees: true,
  },
  {
    id: Math.random(),
    name: "Bravado Banshee じこ",
    url: "https://img.gta5-mods.com/q95/images/alien-styling-bravado-banshee-add-on-tuning-liveries-sounds/a6f7af-EVE-20210603153213.jpg",
    accel: "76%",
    tops: "75%",
    grip: "81%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "RED",
    ees: true,
  },
  {
    id: Math.random(),
    name: "Pegassi Tempesta じこ",
    url: "https://img.gta5-mods.com/q95/images/6str-pegassi-tempesta-custom-tuners-outlaws-add-on-tuneable/a4e77f-C_4wN5tXUAA6jZZ.png",
    accel: "75%",
    tops: "72%",
    grip: "80%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "RED",
    ees: true,
  },
  {
    id: Math.random(),
    name: "Progen Celeste じこ",
    url: "https://img.gta5-mods.com/q95/images/progen-celeste-add-on-tuning-lods-animation/377994-cel1-min.png",
    accel: "79%",
    tops: "78%",
    grip: "75%",
    cat: "S",
    colorC: "green",
    avail: "Boosting",
    colorAv: "RED",
    ees: true,
  },
];
